import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Tabs as PackageTabs } from '@packages/tabs';
import styled from 'styled-components';

export const STYLE = {
    BUTTON_LINK: { height: 20, padding: '0 10px', lineHeight: '20px', margin: 0 },

    CONTENT: {
        CONTAINER: {
            zIndex: 1,
            maxWidth: 1600,
        },
    },

    SIDEBAR: {
        PRICE: {
            border: '1px solid #dedede',
        },
    },
};

export const Headline = styled(Typography).attrs(({ variant }) => ({ variant: variant ?? 'h5' }))`
    && {
        font-weight: normal;
        color: #222;
        font-family: 'Roboto', sans-serif;
    }
`;

export const Tabs = styled(PackageTabs)`
    && {
        .tabs {
            &__indicator {
                display: none;
            }
        }
    }
`;

export const ContentPaper = styled(Paper).attrs(() => ({ elevation: 0 }))`
    && {
        width: 100%;
        border: 1px solid #dedede;
        min-height: 40px;
        position: relative;
        @media screen and (max-width: 959px) {
            border: none !important;
            border-radius: 0 !important;
        }
        .tabs {
            &__holder {
                background-color: #f5f5f5;
            }
            &__content {
                position: relative;
            }
        }
    }
`;

export const TabsWrap = styled.div`
    margin-top: 8px;
    width: inherit;
    .MuiTabs-indicator {
        background-color: #e4002b;
        top: 0;
        bottom: unset;
    }

    .MuiTab-root {
        background-color: #f9f9f9;
        border-bottom: none;
    }

    @media screen and (max-width: 667px) {
        .MuiTab-root {
            min-height: 40px;
            padding: 6px;
        }

        .MuiTab-root .MuiTab-wrapper {
            font-size: 11px;
        }

        .MuiTab-root .MuiTab-wrapper img {
            width: 15px;
        }
    }

    .Mui-selected {
        background-color: #fff;
        border: 1px solid #e0e0e1;
        border-bottom: none;
        .MuiTab-wrapper {
            color: #000000;
        }
        svg {
            color: #5fbaf1;
        }
    }

    .MuiTab-wrapper {
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        letter-spacing: 0.24px;
        color: #0000008a;
        svg {
            margin: 0px !important;
            margin-right: 7px !important;
        }
        img {
            margin: 0px !important;
            margin-right: 7px !important;
        }
    }
`;
export const AddDiscount = styled.p`
    margin-top: 30px;
    margin-left: -15px;
`;
export const DiscountWrap = styled.div`
    position: relative;
    margin-top: 29px;
    margin-left: auto;
    margin-right: -15px;
    .discount-input {
        margin-top: -8px;
        input {
            background-color: #fff;
            border: 1px solid #ccc;
            padding-top: 11px;
            text-align: right;
        }
        .MuiFilledInput-underline:before {
            border: none;
        }
    }
    .dolor {
        color: #555;
        position: absolute;
        top: 5px;
        left: 10px;
        z-index: 9999;
    }
`;
export const DocumentsWrap = styled.div`
    width: 100%;
    & .MuiTypography-subtitle2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.1px;
        color: rgba(0, 0, 0, 0.87);
    }

    & .MuiTypography-caption {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        color: rgba(0, 0, 0, 0.87);
    }
    .drag__ignore {
        color: #000000de;
        letter-spacing: 0.24px;
        font-weight: 500;
        &__disable {
            color: #777;
        }
    }
`;
